import translations from '../../translations';
import type { OrganizationInvite } from '../../types/organization';
import type { UserTenantResponseAPI } from '../../types/user';
import { stringReplace } from '../../utils/string';
import { formatTenantName } from '../../utils/tenant';
import { useOrganizationInvite } from './OrganizationInviteProvider';
import ReceivedInvites from './ReceivedInvites';

type Props = {
    tenant: UserTenantResponseAPI;
};

const ReceivedTenantInviteList = ({ tenant }: Props) => {
    const {
        receivedTenantInvites,
        loadReceivedTenantInvites,
        acceptTenantInvite,
        rejectTenantInvite,
    } = useOrganizationInvite();

    const matchTenantInvite = (invite: OrganizationInvite) => {
        if (invite.type !== 'tenant') {
            return false;
        }

        if (invite.tenant.id !== tenant.id) {
            return false;
        }

        return true;
    };

    const handleAccept = async (id: string) => {
        await acceptTenantInvite(id);
    };

    const handleReject = async (id: string) => {
        await rejectTenantInvite(id);
    };

    return (
        <>
            <p className="description">{translations.FORG_tenant_invitations_description}</p>
            <ReceivedInvites
                caption={stringReplace(translations.FORG_received_tenant_invites_table_caption, {
                    tenantName: formatTenantName(tenant.developerName),
                })}
                invitations={receivedTenantInvites}
                matchInvite={matchTenantInvite}
                loadInvites={loadReceivedTenantInvites}
                onAccept={handleAccept}
                onReject={handleReject}
            />
        </>
    );
};

export default ReceivedTenantInviteList;
